<template>
  <section class="kpi-section">
    <KPIList
      v-for="row of kpiRows"
      :key="row.title"
      :title="row.title"
      :items="row.items"
      :currentPageIndex="currentPageIndex"
      :totalPages="pageLinks.length"
    />
  </section>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import { computed } from 'vue';

import KPIList from "../general/KPIList.vue";


const props = defineProps({
  kpiRows: {
    type: Array,
    default: () => [],
  },
  currentPage: String
});

const { tm } = useI18n();
const pageLinks = computed(() => Object.keys(tm('navigation')));
const currentPageIndex = computed(() => pageLinks.value.indexOf(props.currentPage))
</script>

<style lang="scss" scoped>
.kpi-section {
  position: relative;
  border-top: 1px solid var(--page-color);
}
</style>
